"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastDesc = exports.annualizedCreator = exports.profitPercentCreator = exports.getFormatTimeLasting = exports.complementDigit = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
function complementDigit(value, n) {
    if (`${value}`.length >= n) {
        return `${value}`;
    }
    return `${Array(n).join("0")}${value}`.slice(-n);
}
exports.complementDigit = complementDigit;
const getFormatTimeLasting = (timeInterval) => {
    if (timeInterval > 0) {
        let chaTime = timeInterval;
        const day = 1000 * 60 * 60 * 24; // 一天等于毫秒数
        const hour = 1000 * 60 * 60; // 一小时等于毫秒数
        const dayResult = Math.floor(chaTime / day); //
        chaTime = chaTime - dayResult * day; // 减去天的毫秒数。再求小时个数
        const hourResult = Math.floor(chaTime / hour);
        chaTime = chaTime - hourResult * hour; // 减去小时的毫秒数。再求分钟个数
        const minuteResult = Math.floor(chaTime / (1000 * 60));
        const secondResult = Math.floor((chaTime - minuteResult * 1000 * 60) / 1000); // 减去分钟的毫秒数。再求秒的个数
        return {
            day: complementDigit(dayResult, 2),
            hour: complementDigit(hourResult, 2),
            minute: complementDigit(minuteResult, 2),
            second: complementDigit(secondResult, 2),
        };
    }
    else {
        const defaultZero = complementDigit(0, 2);
        return {
            day: defaultZero,
            hour: defaultZero,
            minute: defaultZero,
            second: defaultZero,
        };
    }
};
exports.getFormatTimeLasting = getFormatTimeLasting;
const profitPercentCreator = (orderData) => {
    /*
    利润率：总利润 /  (quote_invest + base_invest * open_price)
    总利润 data.orderData.originOrderData.bu_order_data.total_profit
    quote_invest: data.orderData.originOrderData.bu_order_data.quote_total_investment
    base_invest: data.orderData.originOrderData.bu_order_data.base_total_investment
    open_price: data.orderData.originOrderData.bu_order_data.open_price
    */
    var _a;
    const bu_order_data = (_a = orderData === null || orderData === void 0 ? void 0 : orderData.originOrderData) === null || _a === void 0 ? void 0 : _a.bu_order_data;
    if (!bu_order_data)
        return 0;
    const { total_profit, quote_total_investment, base_total_investment, open_price } = bu_order_data;
    return new trade_utils_lib_1.SafeDecimal(total_profit)
        .div(new trade_utils_lib_1.SafeDecimal(quote_total_investment).add(new trade_utils_lib_1.SafeDecimal(base_total_investment).plus(new trade_utils_lib_1.SafeDecimal(open_price))))
        .mul(100)
        .toDecimalPlaces(2)
        .valueOf();
};
exports.profitPercentCreator = profitPercentCreator;
const annualizedCreator = (orderData, profitPercent) => {
    var _a;
    const createTimestamp = ((_a = orderData === null || orderData === void 0 ? void 0 : orderData.exchangeGridV3Order) === null || _a === void 0 ? void 0 : _a.triggerTime) || (orderData === null || orderData === void 0 ? void 0 : orderData.timestamp);
    let NumberProfitPercent = Number(profitPercent);
    let tempYearProfitPercent = 0;
    let endTime = new Date().getTime();
    if (profitPercent > 0) {
        tempYearProfitPercent = NumberProfitPercent * ((365 * 24 * 60 * 60 * 1000) / (endTime - createTimestamp));
        if (isNaN(tempYearProfitPercent)) {
            tempYearProfitPercent = 0;
        }
    }
    else {
        let dayResult = (endTime - createTimestamp) / (1000 * 60 * 60 * 24);
        if (dayResult === 0) {
            dayResult = 1;
        }
        tempYearProfitPercent = (Math.pow(1 + NumberProfitPercent / 100, 365 / dayResult) - 1) * 100;
    }
    if (tempYearProfitPercent > 99999) {
        return "99999%+";
    }
    else {
        return trade_utils_lib_1.NumberCommonUtils.toPercent(tempYearProfitPercent);
    }
};
exports.annualizedCreator = annualizedCreator;
/**
 * 获取持续时间
 * @returns
 */
const getLastDesc = ({ createTime, closeTime, $st, }) => {
    const closeOrCurrentTime = !closeTime ? new Date().getTime() : closeTime;
    const value = (0, exports.getFormatTimeLasting)(closeOrCurrentTime - createTime);
    return {
        value,
        display: `${value.day}${$st("grid_order_lasting_day")} ${value.hour}${$st("grid_order_lasting_hour")} ${value.minute}${$st("grid_order_lasting_minute")}`,
    };
};
exports.getLastDesc = getLastDesc;
